
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage header_cart_info btn btn--primary show_cart_subtotal' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('span', { 'className': 'garage-label cm_mobile-hide' }, _translate(`garage_title`)), _createElement('div', { 'className': 'garage-icon-container btn btn--primary' }, _createElement('div', { 'className': 'garage-icon cm_icon_garage__background' }), _createElement('span', { 'className': 'garage-size header_cart_count' }, this.size))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1396'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]